var parent = require('../../es/object/freeze');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/freeze.js
// module id = 570
// module chunks = 0 1